import React from "react";
import { NewSiteDetail } from "../../admin/sites/details";
import withAuthorization from "../../auth/hoc/withAutorization";

const NewSiteRoutes: React.FC = () => {
  return <NewSiteDetail />;
};

export default withAuthorization(NewSiteRoutes);
